import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './_shared/PageHeader'
import ServiceOrderLoader from './_load/ServiceOrderLoader'
import ChildrenServiceOrderLoader from './_load/ChildrenServiceOrderLoader'
import AssetsFieldValuesLoader from './_load/AssetsFieldValuesLoader'

const TemplateManservPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <ChildrenServiceOrderLoader>
          <AssetsFieldValuesLoader>
            <PageHeader templateId={parseInt(templateId)} />
            <PageContent templateId={parseInt(templateId)} />
          </AssetsFieldValuesLoader>
        </ChildrenServiceOrderLoader>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateManservPdfPage
